<div class="basicrow tabtopb f-black roboto-r f-reg" *ngIf="this.screen==2" style="border-top: 0px solid #cccccc; margin-top: 0px; margin-bottom: 40px;">
    <div class="basicr-line f-big">
        Confirmaci&oacute;n
    </div>

    <div class="basicrow m-top-i text-center">
        <div class="shortcont">
            <div class="green-confrm" >
                <i class="fa fa-check-circle checkconfrm" aria-hidden="true"></i>
                <span class="roboto-b">&#161;Gracias por su pago&#33;</span><br/>
                {{this.dataPay.data.confirmText}}
            </div>
            <!-- <div class="basicrow mbott-i"  ng-if="this.screenPaymentType==5">
                <div class="basicrow text-center">
                    <div class="rdtitles">
                        &#161;Gracias por su compra&#33;
                    </div>
                </div>

                <div class="basicrow roboto-r f-black f-reg text-center m-top" >
                    El Servicio Adicional esta disponible para su consumo.					
                </div>
            </div> -->
            <div class="basicrow m-top">
                <div class="logline full"></div>
            </div>

            <div class="basicrow text-center m-top-i">
                Guarda o Imprime la siguiente informaci&oacute;n como evidencia de la transacci&oacute;n:
            </div>

            <div class="basicrow m-bott-ii m-top">
                <div class="userinfo full nomtops">
                    <div class="basicrow">
                        <div class="basicrow text-center">
                            <span class="roboto-b">
                                Monto
                            </span><br>

                            <span class="f-red f-semi roboto-m">
                                ${{this.dataPay.data.mount}}
                            </span>
                        </div>

                        <div class="basicrow m-top">
                            <div class="logline full"></div>
                        </div>
                        <ng-container *ngFor="let list of this.dataPay.data.labels; let i = index">
                            <div class="redstat m-top" *ngIf="list.label!='monto'">
                                <div class="autorow roboto-r pull-left">
                                    {{list.label}}
                                </div>
    
                                <div class="autorow roboto-b pull-right">
                                    {{list.text}}
                                </div>
                            </div>
                        </ng-container>
                        
                        <div class="redstat m-top" ng-if="this.screenPaymentType!=5">
                            <div class="autorow roboto-r pull-left">
                                N&uacute;mero de Transacci&oacute;n
                            </div>
                            <div class="autorow roboto-b pull-right">
                                #{{this.paymentID}}
                            </div>
                        </div>

                        <div class="redstat m-top-ii">
                            <div class="autorow roboto-r pull-left">
                                N&uacute;mero de Confirmaci&oacute;n
                            </div>

                            <div class="autorow roboto-b pull-right">
                                {{this.confirmNum}}
                            </div>
                        </div>

                        <div class="redstat m-top-ii">
                            <div class="autorow roboto-r pull-left">
                                Fecha y Hora
                            </div>

                            <div class="autorow roboto-b pull-right">
                                {{this.allDate}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="basicrow m-top">
                <div class="logline full"></div>
            </div>

            <div class="basicrow text-center m-top-i">
                <a class="btns def-i red pull-right vcenter" ng-click="this.print();">
                    <span class="tabcell">
                        Imprimir
                    </span>
                </a>

                <a (click)="this.return()"  class="btns def-i gray pull-left vcenter">
                    <span class="tabcell">
                        Cerrar
                    </span>
                </a>
            </div>
        </div>
    </div>
</div>